import { GET_AFFORDABLE_HOUSING_RATES } from "../../actionTypes/actionsTypes";
import defaultAsyncReducer from "../../defaultReducer";
import { AppAction, BaseAsyncReducerState } from "../../types";

export interface GetAffordableHousingRatesState extends BaseAsyncReducerState {
    data: Record<string, unknown>[];
}

// Define an initial state value for the app
const initialState: GetAffordableHousingRatesState = {
    success: false,
    loading: false,
    error: false,
    data: []
}

function getAffordableHousingRatesReducer(state = initialState, action: AppAction) {
    return defaultAsyncReducer(state, action as AppAction, GET_AFFORDABLE_HOUSING_RATES)
}

export default getAffordableHousingRatesReducer;